function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _templateObject() {
    var data = _taggedTemplateLiteral(['Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.This may prevent text tracks from loading.']);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== 'undefined' && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base)
                return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _getPrototypeOf(object);
        if (object === null)
            break;
    }
    return object;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
import Tech from './tech.js';
import * as Dom from '@emav-util/dom.js';
import * as Url from '@emav-util/url.js';
import log from '@emav-util/log.js';
import tsml from 'tsml';
import * as browser from '@emav-util/browser.js';
import document from 'global/document';
import window from 'global/window';
import { assign } from '@emav-util/obj';
import mergeOptions from '@emav-util/merge-options.js';
import toTitleCase from '@emav-util/to-title-case.js';
import { NORMAL as TRACK_TYPES } from '../tracks/track-types';
import setupSourceset from './setup-sourceset';
var Html5 = function (_Tech) {
    _inherits(Html5, _Tech);
    function Html5(options, ready) {
        var _this;
        _classCallCheck(this, Html5);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(Html5).call(this, options, ready));
        var source = options.source;
        var crossoriginTracks = false;
        if (source && (_this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) {
            _this.setSource(source);
        } else {
            _this.handleLateInit_(_this.el_);
        }
        if (options.enableSourceset) {
            _this.setupSourcesetHandling_();
        }
        if (_this.el_.hasChildNodes()) {
            var nodes = _this.el_.childNodes;
            var nodesLength = nodes.length;
            var removeNodes = [];
            while (nodesLength--) {
                var node = nodes[nodesLength];
                var nodeName = node.nodeName.toLowerCase();
                if (nodeName === 'track') {
                    if (!_this.featuresNativeTextTracks) {
                        removeNodes.push(node);
                    } else {
                        _this.remoteTextTrackEls().addTrackElement_(node);
                        _this.remoteTextTracks().addTrack(node.track);
                        _this.textTracks().addTrack(node.track);
                        if (!crossoriginTracks && !_this.el_.hasAttribute('crossorigin') && Url.isCrossOrigin(node.src)) {
                            crossoriginTracks = true;
                        }
                    }
                }
            }
            for (var i = 0; i < removeNodes.length; i++) {
                _this.el_.removeChild(removeNodes[i]);
            }
        }
        _this.proxyNativeTracks_();
        if (_this.featuresNativeTextTracks && crossoriginTracks) {
            log.warn(tsml(_templateObject()));
        }
        _this.restoreMetadataTracksInIOSNativePlayer_();
        if ((browser.TOUCH_ENABLED || browser.IS_IPHONE || browser.IS_NATIVE_ANDROID) && options.nativeControlsForTouch === true) {
            _this.setControls(true);
        }
        _this.proxyWebkitFullscreen_();
        _this.triggerReady();
        return _this;
    }
    _createClass(Html5, [
        {
            key: 'dispose',
            value: function dispose() {
                if (this.el_ && this.el_.resetSourceset_) {
                    this.el_.resetSourceset_();
                }
                _get(_getPrototypeOf(Html5.prototype), 'dispose', this).call(this);
            }
        },
        {
            key: 'setupSourcesetHandling_',
            value: function setupSourcesetHandling_() {
                setupSourceset(this);
            }
        },
        {
            key: 'restoreMetadataTracksInIOSNativePlayer_',
            value: function restoreMetadataTracksInIOSNativePlayer_() {
                var textTracks = this.textTracks();
                var metadataTracksPreFullscreenState;
                var takeMetadataTrackSnapshot = function takeMetadataTrackSnapshot() {
                    metadataTracksPreFullscreenState = [];
                    for (var i = 0; i < textTracks.length; i++) {
                        var track = textTracks[i];
                        if (track.kind === 'metadata') {
                            metadataTracksPreFullscreenState.push({
                                track: track,
                                storedMode: track.mode
                            });
                        }
                    }
                };
                takeMetadataTrackSnapshot();
                textTracks.addEventListener('change', takeMetadataTrackSnapshot);
                this.on('dispose', function () {
                    return textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
                });
                var restoreTrackMode = function restoreTrackMode() {
                    for (var i = 0; i < metadataTracksPreFullscreenState.length; i++) {
                        var storedTrack = metadataTracksPreFullscreenState[i];
                        if (storedTrack.track.mode === 'disabled' && storedTrack.track.mode !== storedTrack.storedMode) {
                            storedTrack.track.mode = storedTrack.storedMode;
                        }
                    }
                    textTracks.removeEventListener('change', restoreTrackMode);
                };
                this.on('webkitbeginfullscreen', function () {
                    textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
                    textTracks.removeEventListener('change', restoreTrackMode);
                    textTracks.addEventListener('change', restoreTrackMode);
                });
                this.on('webkitendfullscreen', function () {
                    textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
                    textTracks.addEventListener('change', takeMetadataTrackSnapshot);
                    textTracks.removeEventListener('change', restoreTrackMode);
                });
            }
        },
        {
            key: 'overrideNative_',
            value: function overrideNative_(type, override) {
                var _this2 = this;
                if (override !== this['featuresNative'.concat(type, 'Tracks')]) {
                    return;
                }
                var lowerCaseType = type.toLowerCase();
                if (this[''.concat(lowerCaseType, 'TracksListeners_')]) {
                    Object.keys(this[''.concat(lowerCaseType, 'TracksListeners_')]).forEach(function (eventName) {
                        var elTracks = _this2.el()[''.concat(lowerCaseType, 'Tracks')];
                        elTracks.removeEventListener(eventName, _this2[''.concat(lowerCaseType, 'TracksListeners_')][eventName]);
                    });
                }
                this['featuresNative'.concat(type, 'Tracks')] = !override;
                this[''.concat(lowerCaseType, 'TracksListeners_')] = null;
            }
        },
        {
            key: 'overrideNativeAudioTracks',
            value: function overrideNativeAudioTracks(override) {
                this.overrideNative_('Audio', override);
            }
        },
        {
            key: 'overrideNativeVideoTracks',
            value: function overrideNativeVideoTracks(override) {
                this.overrideNative_('Video', override);
            }
        },
        {
            key: 'proxyNativeTracksForType_',
            value: function proxyNativeTracksForType_(name) {
                var _this3 = this;
                var props = TRACK_TYPES[name];
                var elTracks = this.el()[props.getterName];
                var techTracks = this[props.getterName]();
                if (!this['featuresNative'.concat(props.capitalName, 'Tracks')] || !elTracks || !elTracks.addEventListener) {
                    return;
                }
                var listeners = {
                    change: function change(e) {
                        techTracks.trigger({
                            type: 'change',
                            target: techTracks,
                            currentTarget: techTracks,
                            srcElement: techTracks
                        });
                    },
                    addtrack: function addtrack(e) {
                        techTracks.addTrack(e.track);
                    },
                    removetrack: function removetrack(e) {
                        techTracks.removeTrack(e.track);
                    }
                };
                var removeOldTracks = function removeOldTracks() {
                    var removeTracks = [];
                    for (var i = 0; i < techTracks.length; i++) {
                        var found = false;
                        for (var j = 0; j < elTracks.length; j++) {
                            if (elTracks[j] === techTracks[i]) {
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            removeTracks.push(techTracks[i]);
                        }
                    }
                    while (removeTracks.length) {
                        techTracks.removeTrack(removeTracks.shift());
                    }
                };
                this[props.getterName + 'Listeners_'] = listeners;
                Object.keys(listeners).forEach(function (eventName) {
                    var listener = listeners[eventName];
                    elTracks.addEventListener(eventName, listener);
                    _this3.on('dispose', function (e) {
                        return elTracks.removeEventListener(eventName, listener);
                    });
                });
                this.on('loadstart', removeOldTracks);
                this.on('dispose', function (e) {
                    return _this3.off('loadstart', removeOldTracks);
                });
            }
        },
        {
            key: 'proxyNativeTracks_',
            value: function proxyNativeTracks_() {
            }
        },
        {
            key: 'handleTouch',
            value: function handleTouch(event) {
            }
        },
        {
            key: 'handleLateInit_',
            value: function handleLateInit_(el) {
                if (el.networkState === 0 || el.networkState === 3) {
                    return;
                }
                if (el.readyState === 0) {
                    var loadstartFired = false;
                    var setLoadstartFired = function setLoadstartFired() {
                        loadstartFired = true;
                    };
                    this.on('loadstart', setLoadstartFired);
                    var triggerLoadstart = function triggerLoadstart() {
                        if (!loadstartFired) {
                            this.trigger('loadstart');
                        }
                    };
                    this.on('loadedmetadata', triggerLoadstart);
                    this.ready(function () {
                        this.off('loadstart', setLoadstartFired);
                        this.off('loadedmetadata', triggerLoadstart);
                        if (!loadstartFired) {
                            this.trigger('loadstart');
                        }
                    });
                    return;
                }
                var eventsToTrigger = ['loadstart'];
                eventsToTrigger.push('loadedmetadata');
                if (el.readyState >= 2) {
                    eventsToTrigger.push('loadeddata');
                }
                if (el.readyState >= 3) {
                    eventsToTrigger.push('canplay');
                }
                if (el.readyState >= 4) {
                    eventsToTrigger.push('canplaythrough');
                }
                this.ready(function () {
                    eventsToTrigger.forEach(function (type) {
                        this.trigger(type);
                    }, this);
                });
            }
        },
        {
            key: 'setCurrentTime',
            value: function setCurrentTime(seconds) {
                try {
                    this.el_.currentTime = seconds;
                } catch (e) {
                    log(e, 'Video is not ready. (emav.js)');
                }
            }
        },
        {
            key: 'duration',
            value: function duration() {
                var _this4 = this;
                if (this.el_.duration === Infinity && browser.IS_ANDROID && browser.IS_CHROME && this.el_.currentTime === 0) {
                    var checkProgress = function checkProgress() {
                        if (_this4.el_.currentTime > 0) {
                            if (_this4.el_.duration === Infinity) {
                                _this4.trigger('durationchange');
                            }
                            _this4.off('timeupdate', checkProgress);
                        }
                    };
                    this.on('timeupdate', checkProgress);
                    return NaN;
                }
                return this.el_.duration || NaN;
            }
        },
        {
            key: 'width',
            value: function width() {
                return this.el_.offsetWidth;
            }
        },
        {
            key: 'height',
            value: function height() {
                return this.el_.offsetHeight;
            }
        },
        {
            key: 'proxyWebkitFullscreen_',
            value: function proxyWebkitFullscreen_() {
                var _this5 = this;
                if (!('webkitDisplayingFullscreen' in this.el_)) {
                    return;
                }
                var endFn = function endFn() {
                    this.trigger('fullscreenchange', { isFullscreen: false });
                };
                var beginFn = function beginFn() {
                    if ('webkitPresentationMode' in this.el_ && this.el_.webkitPresentationMode !== 'picture-in-picture') {
                        this.one('webkitendfullscreen', endFn);
                        this.trigger('fullscreenchange', { isFullscreen: true });
                    }
                };
                this.on('webkitbeginfullscreen', beginFn);
                this.on('dispose', function () {
                    _this5.off('webkitbeginfullscreen', beginFn);
                    _this5.off('webkitendfullscreen', endFn);
                });
            }
        },
        {
            key: 'supportsFullScreen',
            value: function supportsFullScreen() {
                if (typeof this.el_.webkitEnterFullScreen === 'function') {
                    var userAgent = window.navigator && window.navigator.userAgent || '';
                    if (/Android/.test(userAgent) || !/Chrome|Mac OS X 10.5/.test(userAgent)) {
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: 'enterFullScreen',
            value: function enterFullScreen() {
                var video = this.el_;
                if (video.paused && video.networkState <= video.HAVE_METADATA) {
                    this.el_.play();
                    this.setTimeout(function () {
                        video.pause();
                        video.webkitEnterFullScreen();
                    }, 0);
                } else {
                    video.webkitEnterFullScreen();
                }
            }
        },
        {
            key: 'exitFullScreen',
            value: function exitFullScreen() {
                this.el_.webkitExitFullScreen();
            }
        },
        {
            key: 'src',
            value: function src(_src) {
                if (_src === undefined) {
                    return this.el_.src;
                }
                this.setSrc(_src);
            }
        },
        {
            key: 'reset',
            value: function reset() {
                Html5.resetMediaElement(this.el_);
            }
        },
        {
            key: 'currentSrc',
            value: function currentSrc() {
                if (this.currentSource_) {
                    return this.currentSource_.src;
                }
                return this.el_.currentSrc;
            }
        },
        {
            key: 'setControls',
            value: function setControls(val) {
                this.el_.controls = !!val;
            }
        },
        {
            key: 'addTextTrack',
            value: function addTextTrack(kind, label, language) {
                if (!this.featuresNativeTextTracks) {
                    return _get(_getPrototypeOf(Html5.prototype), 'addTextTrack', this).call(this, kind, label, language);
                }
                return this.el_.addTextTrack(kind, label, language);
            }
        },
        {
            key: 'createRemoteTextTrack',
            value: function createRemoteTextTrack(options) {
                if (!this.featuresNativeTextTracks) {
                    return _get(_getPrototypeOf(Html5.prototype), 'createRemoteTextTrack', this).call(this, options);
                }
                var htmlTrackElement = document.createElement('track');
                if (options.kind) {
                    htmlTrackElement.kind = options.kind;
                }
                if (options.label) {
                    htmlTrackElement.label = options.label;
                }
                if (options.language || options.srclang) {
                    htmlTrackElement.srclang = options.language || options.srclang;
                }
                if (options['default']) {
                    htmlTrackElement['default'] = options['default'];
                }
                if (options.id) {
                    htmlTrackElement.id = options.id;
                }
                if (options.src) {
                    htmlTrackElement.src = options.src;
                }
                return htmlTrackElement;
            }
        },
        {
            key: 'addRemoteTextTrack',
            value: function addRemoteTextTrack(options, manualCleanup) {
                var htmlTrackElement = _get(_getPrototypeOf(Html5.prototype), 'addRemoteTextTrack', this).call(this, options, manualCleanup);
                if (this.featuresNativeTextTracks) {
                    this.el().appendChild(htmlTrackElement);
                }
                return htmlTrackElement;
            }
        },
        {
            key: 'removeRemoteTextTrack',
            value: function removeRemoteTextTrack(track) {
                _get(_getPrototypeOf(Html5.prototype), 'removeRemoteTextTrack', this).call(this, track);
                if (this.featuresNativeTextTracks) {
                    var tracks = this.$$('track');
                    var i = tracks.length;
                    while (i--) {
                        if (track === tracks[i] || track === tracks[i].track) {
                            this.el().removeChild(tracks[i]);
                        }
                    }
                }
            }
        },
        {
            key: 'getVideoPlaybackQuality',
            value: function getVideoPlaybackQuality() {
                if (typeof this.el().getVideoPlaybackQuality === 'function') {
                    return this.el().getVideoPlaybackQuality();
                }
                var videoPlaybackQuality = {};
                if (typeof this.el().webkitDroppedFrameCount !== 'undefined' && typeof this.el().webkitDecodedFrameCount !== 'undefined') {
                    videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
                    videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
                }
                if (window.performance && typeof window.performance.now === 'function') {
                    videoPlaybackQuality.creationTime = window.performance.now();
                } else if (window.performance && window.performance.timing && typeof window.performance.timing.navigationStart === 'number') {
                    videoPlaybackQuality.creationTime = window.Date.now() - window.performance.timing.navigationStart;
                }
                return videoPlaybackQuality;
            }
        }
    ]);
    return Html5;
}(Tech);
if (Dom.isReal()) {
    Html5.TEST_VID = document.createElement('video');
    var track = document.createElement('track');
    track.kind = 'captions';
    track.srclang = 'en';
    track.label = 'English';
    Html5.TEST_VID.appendChild(track);
}
Html5.isSupported = function () {
    try {
        Html5.TEST_VID.volume = 0.5;
    } catch (e) {
        return false;
    }
    return !!(Html5.TEST_VID && Html5.TEST_VID.canPlayType);
};
Html5.canPlayType = function (type) {
    return Html5.TEST_VID.canPlayType(type);
};
Html5.canPlaySource = function (srcObj, options) {
    return Html5.canPlayType(srcObj.type);
};
Html5.canControlVolume = function () {
    try {
        var volume = Html5.TEST_VID.volume;
        Html5.TEST_VID.volume = volume / 2 + 0.1;
        return volume !== Html5.TEST_VID.volume;
    } catch (e) {
        return false;
    }
};
Html5.canMuteVolume = function () {
    try {
        var muted = Html5.TEST_VID.muted;
        Html5.TEST_VID.muted = !muted;
        if (Html5.TEST_VID.muted) {
            Dom.setAttribute(Html5.TEST_VID, 'muted', 'muted');
        } else {
            Dom.removeAttribute(Html5.TEST_VID, 'muted', 'muted');
        }
        return muted !== Html5.TEST_VID.muted;
    } catch (e) {
        return false;
    }
};
Html5.canControlPlaybackRate = function () {
    if (browser.IS_ANDROID && browser.IS_CHROME && browser.CHROME_VERSION < 58) {
        return false;
    }
    try {
        var playbackRate = Html5.TEST_VID.playbackRate;
        Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
        return playbackRate !== Html5.TEST_VID.playbackRate;
    } catch (e) {
        return false;
    }
};
Html5.canOverrideAttributes = function () {
    try {
        var noop = function noop() {
        };
        Object.defineProperty(document.createElement('video'), 'src', {
            get: noop,
            set: noop
        });
        Object.defineProperty(document.createElement('audio'), 'src', {
            get: noop,
            set: noop
        });
        Object.defineProperty(document.createElement('video'), 'innerHTML', {
            get: noop,
            set: noop
        });
        Object.defineProperty(document.createElement('audio'), 'innerHTML', {
            get: noop,
            set: noop
        });
    } catch (e) {
        return false;
    }
    return true;
};
Html5.supportsNativeTextTracks = function () {
    return browser.IS_ANY_SAFARI || browser.IS_IOS && browser.IS_CHROME;
};
Html5.supportsNativeVideoTracks = function () {
    return !!(Html5.TEST_VID && Html5.TEST_VID.videoTracks);
};
Html5.supportsNativeAudioTracks = function () {
    return !!(Html5.TEST_VID && Html5.TEST_VID.audioTracks);
};
Html5.Events = [
    'loadstart',
    'suspend',
    'abort',
    'error',
    'emptied',
    'stalled',
    'loadedmetadata',
    'loadeddata',
    'canplay',
    'canplaythrough',
    'playing',
    'waiting',
    'seeking',
    'seeked',
    'ended',
    'durationchange',
    'timeupdate',
    'progress',
    'play',
    'pause',
    'ratechange',
    'resize',
    'volumechange'
];
Html5.prototype.featuresVolumeControl = Html5.canControlVolume();
Html5.prototype.featuresMuteControl = Html5.canMuteVolume();
Html5.prototype.featuresPlaybackRate = Html5.canControlPlaybackRate();
Html5.prototype.featuresSourceset = Html5.canOverrideAttributes();
Html5.prototype.movingMediaElementInDOM = !browser.IS_IOS;
Html5.prototype.featuresFullscreenResize = true;
Html5.prototype.featuresProgressEvents = true;
Html5.prototype.featuresTimeupdateEvents = true;
Html5.prototype.featuresNativeTextTracks = Html5.supportsNativeTextTracks();
Html5.prototype.featuresNativeVideoTracks = Html5.supportsNativeVideoTracks();
Html5.prototype.featuresNativeAudioTracks = Html5.supportsNativeAudioTracks();
var canPlayType = Html5.TEST_VID && Html5.TEST_VID.constructor.prototype.canPlayType;
var mpegurlRE = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
Html5.patchCanPlayType = function () {
    if (browser.ANDROID_VERSION >= 4 && !browser.IS_FIREFOX && !browser.IS_CHROME) {
        Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
            if (type && mpegurlRE.test(type)) {
                return 'maybe';
            }
            return canPlayType.call(this, type);
        };
    }
};
Html5.unpatchCanPlayType = function () {
    var r = Html5.TEST_VID.constructor.prototype.canPlayType;
    Html5.TEST_VID.constructor.prototype.canPlayType = canPlayType;
    return r;
};
Html5.patchCanPlayType();
Html5.disposeMediaElement = function (el) {
    if (!el) {
        return;
    }
    if (el.parentNode) {
        el.parentNode.removeChild(el);
    }
    while (el.hasChildNodes()) {
        el.removeChild(el.firstChild);
    }
    el.removeAttribute('src');
    if (typeof el.load === 'function') {
        (function () {
            try {
                el.load();
            } catch (e) {
            }
        }());
    }
};
Html5.resetMediaElement = function (el) {
    if (!el) {
        return;
    }
    var sources = el.querySelectorAll('source');
    var i = sources.length;
    while (i--) {
        el.removeChild(sources[i]);
    }
    el.removeAttribute('src');
    if (typeof el.load === 'function') {
        (function () {
            try {
                el.load();
            } catch (e) {
            }
        }());
    }
};
[
    'muted',
    'defaultMuted',
    'autoplay',
    'controls',
    'loop',
    'playsinline'
].forEach(function (prop) {
    Html5.prototype[prop] = function () {
        return this.el_[prop] || this.el_.hasAttribute(prop);
    };
});
[
    'muted',
    'defaultMuted',
    'autoplay',
    'loop',
    'playsinline'
].forEach(function (prop) {
    Html5.prototype['set' + toTitleCase(prop)] = function (v) {
        this.el_[prop] = v;
        if (v) {
            this.el_.setAttribute(prop, prop);
        } else {
            this.el_.removeAttribute(prop);
        }
    };
});
[
    'paused',
    'currentTime',
    'buffered',
    'volume',
    'poster',
    'preload',
    'error',
    'seeking',
    'seekable',
    'ended',
    'playbackRate',
    'defaultPlaybackRate',
    'played',
    'networkState',
    'readyState',
    'videoWidth',
    'videoHeight'
].forEach(function (prop) {
    Html5.prototype[prop] = function () {
        return this.el_[prop];
    };
});
[
    'volume',
    'src',
    'poster',
    'preload',
    'playbackRate',
    'defaultPlaybackRate'
].forEach(function (prop) {
    Html5.prototype['set' + toTitleCase(prop)] = function (v) {
        this.el_[prop] = v;
    };
});
[
    'pause',
    'load',
    'play'
].forEach(function (prop) {
    Html5.prototype[prop] = function () {
        return this.el_[prop]();
    };
});
Tech.withSourceHandlers(Html5);
Html5.nativeSourceHandler = { name: 'Html5' };
Html5.nativeSourceHandler.canPlayType = function (type) {
    try {
        return Html5.TEST_VID.canPlayType(type);
    } catch (e) {
        return '';
    }
};
Html5.nativeSourceHandler.canHandleSource = function (source, options) {
    if (source.type) {
        return Html5.nativeSourceHandler.canPlayType(source.type);
    } else if (source.src) {
        var ext = Url.getFileExtension(source.src);
        return Html5.nativeSourceHandler.canPlayType('video/'.concat(ext));
    }
    return '';
};
Html5.nativeSourceHandler.handleSource = function (source, tech, options) {
    tech.setSrc(source.src);
};
Html5.nativeSourceHandler.dispose = function () {
};
Html5.registerSourceHandler(Html5.nativeSourceHandler);
Tech.registerTech('Html5', Html5);
export default Html5;